const CustomPopupContent = ({
  title,
  gridRef,
  coordinates,
  elevation,
  onRemovePin,
  showActions = true,
  isCorrect = null,
}) => {
  const statusText =
    isCorrect !== null ? (isCorrect ? "✓ Correct" : "✗ Incorrect") : null;

  return (
    <div className="custom-popup">
      <div className="popup-header">
        <h3 className="popup-title">{title}</h3>
        {statusText && (
          <span
            className={`status-badge ${isCorrect ? "correct" : "incorrect"}`}
          >
            {statusText}
          </span>
        )}
      </div>

      <div className="popup-content">
        <div className="coordinate-row">
          <span className="coordinate-label">Grid Ref: </span>
          <span className="coordinate-value">{gridRef}</span>
        </div>

        <div className="coordinate-row">
          <span className="coordinate-label">Lat, Long: </span>
          <span className="coordinate-value">
            {coordinates.lat.toFixed(5)}, {coordinates.lng.toFixed(5)}
          </span>
        </div>

        {elevation && (
          <div className="coordinate-row">
            <span className="coordinate-label">Elevation: </span>
            <span className="coordinate-value">{elevation} m</span>
          </div>
        )}
      </div>

      {showActions && (
        <div className="popup-actions">
          {/* <button className="popup-button" onClick={onViewDetails}>
            View details
          </button> */}
          <button className="popup-button" onClick={onRemovePin}>
            Remove Pin
          </button>
        </div>
      )}
    </div>
  );
};
export default CustomPopupContent;
